import { routeConfig } from "@/routes/route";
import { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";
import { registerIcons } from "@fluentui/react/lib/Styling";
registerIcons({
  icons: {
    "billing-svg": (<svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 4.28906V16H0V0H8.71094L13 4.28906ZM9 4H11.2891L9 1.71094V4ZM12 5H8V1H1V15H12V5ZM7 7.00781H3V6H7V7.00781ZM7 9.00781H3V8H7V9.00781ZM7 11.0078H3V10H7V11.0078ZM3 12H9.99219V13.0078H3V12Z" fill="#323130" />
    </svg>
    ),

    "order-svg": (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 9V8H7V9H4ZM7 6V7H4V6H7ZM7 4V5H4V4H7ZM12 5H8V1H1V15H8V16H0V0H8.71094L13 4.28906V9H12V5ZM9 1.71094V4H11.2891L9 1.71094ZM9 10H16V16H9V10ZM15 15V11H10V15H15ZM14 12V14H13V12H14ZM12 12V14H11V12H12ZM3 6V7H2V6H3ZM2 9V8H3V9H2ZM3 4V5H2V4H3Z" fill="#323130" />
      </svg>
    ),
    "inquiryorder-svg": (
      <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 6V7H4V6H7ZM1 1V15H4.96094L4.71094 16H0V0H8.71094L13 4.28906V5.80469C12.651 5.85677 12.3177 5.97135 12 6.14844V5H8V1H1ZM9 1.71094V4H11.2891L9 1.71094ZM4 9V8H7V9H4ZM3 6V7H2V6H3ZM2 9V8H3V9H2ZM7 4V5H4V4H7ZM3 4V5H2V4H3ZM15 8.54688C15 8.75 14.9609 8.94792 14.8828 9.14062C14.8047 9.33333 14.6927 9.5026 14.5469 9.64844L8.94531 15.2656L6 16L6.73438 13.0547L12.3359 7.44531C12.4818 7.29948 12.651 7.1901 12.8438 7.11719C13.0365 7.03906 13.2344 7 13.4375 7C13.6562 7 13.8594 7.03906 14.0469 7.11719C14.2396 7.19531 14.4062 7.30469 14.5469 7.44531C14.6875 7.58594 14.7969 7.75 14.875 7.9375C14.9583 8.125 15 8.32812 15 8.54688ZM14 8.54688C14 8.38021 13.9479 8.2474 13.8438 8.14844C13.7396 8.04948 13.6042 8 13.4375 8C13.3646 8 13.2943 8.01302 13.2266 8.03906C13.1589 8.0599 13.099 8.09635 13.0469 8.14844L7.64062 13.5703L7.375 14.625L8.42969 14.3594L13.8359 8.94531C13.9453 8.83594 14 8.70312 14 8.54688Z" fill="#323130" />
      </svg>
    ),
    "certificate-svg": (
      <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 10C6 10.4271 5.91146 10.8359 5.73438 11.2266C5.5625 11.612 5.31771 11.9479 5 12.2344V15.8125L3 14.8125L1 15.8125V12.2344C0.682292 11.9479 0.434896 11.612 0.257812 11.2266C0.0859375 10.8359 0 10.4271 0 10C0 9.58854 0.078125 9.20052 0.234375 8.83594C0.390625 8.47135 0.604167 8.15365 0.875 7.88281C1.15104 7.60677 1.46875 7.39062 1.82812 7.23438C2.19271 7.07812 2.58333 7 3 7C3.41146 7 3.79948 7.08073 4.16406 7.24219C4.52865 7.39844 4.84635 7.61198 5.11719 7.88281C5.38802 8.15365 5.60156 8.47135 5.75781 8.83594C5.91927 9.20052 6 9.58854 6 10ZM3 12C3.27604 12 3.53385 11.9479 3.77344 11.8438C4.01823 11.7396 4.23177 11.5964 4.41406 11.4141C4.59635 11.2318 4.73958 11.0208 4.84375 10.7812C4.94792 10.5365 5 10.276 5 10C5 9.72396 4.94792 9.46615 4.84375 9.22656C4.73958 8.98177 4.59635 8.76823 4.41406 8.58594C4.23177 8.40365 4.01823 8.26042 3.77344 8.15625C3.53385 8.05208 3.27604 8 3 8C2.72396 8 2.46354 8.05208 2.21875 8.15625C1.97917 8.26042 1.76823 8.40365 1.58594 8.58594C1.40365 8.76823 1.26042 8.98177 1.15625 9.22656C1.05208 9.46615 1 9.72396 1 10C1 10.276 1.05208 10.5365 1.15625 10.7812C1.26042 11.0208 1.40365 11.2318 1.58594 11.4141C1.76823 11.5964 1.97917 11.7396 2.21875 11.8438C2.46354 11.9479 2.72396 12 3 12ZM4 12.8281C3.68229 12.9427 3.36198 13 3.03906 13C2.67448 13 2.32812 12.9427 2 12.8281V14.1875L3 13.6875L4 14.1875V12.8281ZM14 4.28906V16H6V15H13V5H9V1H2V5.875C1.82812 5.91667 1.65625 5.96875 1.48438 6.03125C1.31771 6.09375 1.15625 6.16667 1 6.25V0H9.71094L14 4.28906ZM12.2891 4L10 1.71094V4H12.2891Z" fill="#323130" />
      </svg>
    ),
    "supercard-svg": (
      <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.5 0C1.11929 0 0 1.11929 0 2.5V9.5C0 10.8807 1.11929 12 2.5 12H13.5C14.8807 12 16 10.8807 16 9.5V2.5C16 1.11929 14.8807 0 13.5 0H2.5ZM1 2.5C1 1.67157 1.67157 1 2.5 1H13.5C14.3284 1 15 1.67157 15 2.5V9.5C15 10.3284 14.3284 11 13.5 11H2.5C1.67157 11 1 10.3284 1 9.5V2.5ZM2.5 2C2.22386 2 2 2.22386 2 2.5C2 2.77614 2.22386 3 2.5 3H7.5C7.77614 3 8 2.77614 8 2.5C8 2.22386 7.77614 2 7.5 2H2.5ZM2.5 4C2.22386 4 2 4.22386 2 4.5C2 4.77614 2.22386 5 2.5 5H10.5C10.7761 5 11 4.77614 11 4.5C11 4.22386 10.7761 4 10.5 4H2.5ZM3 7C2.44772 7 2 7.44771 2 8V9C2 9.55228 2.44772 10 3 10H7C7.55228 10 8 9.55228 8 9V8C8 7.44772 7.55228 7 7 7H3Z" fill="currentColor" />
      </svg>
    ),
    "addbutton-svg": (
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 0C1.34315 0 0 1.34315 0 3V11C0 12.6569 1.34315 14 3 14H11C12.6569 14 14 12.6569 14 11V3C14 1.34315 12.6569 0 11 0H3ZM1 3C1 1.89543 1.89543 1 3 1H11C12.1046 1 13 1.89543 13 3V11C13 12.1046 12.1046 13 11 13H3C1.89543 13 1 12.1046 1 11V3ZM7.5 3.50021C7.5 3.22407 7.27614 3.00021 7 3.00021C6.72386 3.00021 6.5 3.22407 6.5 3.50021V6.50021H3.5C3.22386 6.50021 3 6.72407 3 7.00021C3 7.27636 3.22386 7.50021 3.5 7.50021H6.5V10.5002C6.5 10.7764 6.72386 11.0002 7 11.0002C7.27614 11.0002 7.5 10.7764 7.5 10.5002V7.50021H10.5C10.7761 7.50021 11 7.27636 11 7.00021C11 6.72407 10.7761 6.50021 10.5 6.50021H7.5V3.50021Z" fill="currentColor" />
      </svg>
    ),
  },
});
const LazyLoad = (path: string) => {
  const Comp = lazy(() => import("@BZA/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

export const useSettlementCIDRouterConfig = () => {
  const { t } = useTranslation();

  return [
    {
      path: "/waitingOrder",
      element: LazyLoad("AgencyManagement/WaitingOrderManagement"),
      name: t("routes.PurchaseOrderManagement"),
      key: "waitingOrderKey",
      icon: "inquiryorder-svg",
    },
    {
      path: "/completeorder",
      element: LazyLoad("AgencyManagement/CompleteorderManagement"),
      name: t("routes.orderManagement"),
      key: "completeorderKey",
      icon: "order-svg",
    },
    {
      path: "/waitingOrder/inquirydetails/:cid/:inquiryId",
      element: LazyLoad("AgencyManagement/WaitingOrderManagement/detailedInformation"),
      name: t("routes.viewQuotation"),
      key: "waitingOrderInquirydetailsKey",
      isHidden: true,
      fromPath: "/waitingOrder",
      pathReg: /\/waitingOrder\/inquirydetails\/\d+\/\d+/,
    },
    {
      path: "/completeorder/details/:cid/:inquiryId",
      element: LazyLoad("AgencyManagement/CompleteorderManagement/detailedInformation"),
      name: t("routes.orderDetails"),
      key: "completeorderdetailsKey",
      isHidden: true,
      fromPath: "/completeorder",
      pathReg: /\/completeorder\/details\/\d+\/\d+/,
    },
    {
      path: "/billingManagement",
      element: LazyLoad("AgencyManagement/BillingManagement/index.tsx"),
      name: t("routes.billingManagement"),
      key: "billingManagementKey",
      icon: "billing-svg",
    },
  ];
};

export const SettlementCIDRouter: routeConfig[] = [
  {
    path: "/waitingOrder",
    element: LazyLoad("AgencyManagement/WaitingOrderManagement"),
    name: "下单管理",
    key: "waitingOrderKey",
    icon: "inquiryorder-svg",
  },
  {
    path: "/completeorder",
    element: LazyLoad("AgencyManagement/CompleteorderManagement"),
    name: "订单管理",
    key: "completeorderKey",
    icon: "order-svg",
  },
  {
    path: "/waitingOrder/inquirydetails/:cid/:inquiryId",
    element: LazyLoad("AgencyManagement/WaitingOrderManagement/detailedInformation"),
    name: "查看报价",
    key: "waitingOrderInquirydetailsKey",
    isHidden: true,
    fromPath: "/waitingOrder",
    pathReg: /\/waitingOrder\/inquirydetails\/\d+\/\d+/,
  },
  {
    path: "/completeorder/details/:cid/:inquiryId",
    element: LazyLoad("AgencyManagement/CompleteorderManagement/detailedInformation"),
    name: "订单详情",
    key: "completeorderdetailsKey",
    isHidden: true,
    fromPath: "/completeorder",
    pathReg: /\/completeorder\/details\/\d+\/\d+/,
  },
  {
    path: "/billingManagement",
    element: LazyLoad("AgencyManagement/BillingManagement/index.tsx"),
    name: "结算管理",
    key: "billingManagementKey",
    icon: "billing-svg",
  },
];
